import api from "./api";

export const login = async (email: string, password: string, subdomain?: string, portal?: string) => {
  const res = await api.post("/api/auth/login", {
    email,
    password,
    subdomain,
    portal,
  });
  return res.data;
};
